<div>

  <div fxLayout="row" *ngIf="loginFailed">
    <div fxLayout="column" fxFlex="10" fxFlex.xs="5"></div>
    <div fxLayout="column" fxFlex="80" fxFlex.xs="90" fxLayoutAlign="center center" style="color: brown;">
      Apologies, the login attempt failed. Please reload the page and try logging in again.
    </div>
    <div fxLayout="column" fxFlex="10" fxFlex.xs="5"></div>
  </div>
  <div fxLayout="row">
    <div fxLayout="column" fxFlex="10" fxFlex.xs="5"></div>
    <div fxLayout="column" fxFlex="80" fxFlex.xs="90">
      <div fxFlexlayout="row" style="height: 5ch"></div>
      <div *ngIf="!hidetitle" fxFlexlayout="row" [@fade]="[text]" class="mat-h2 auto_margin" fxLayoutAlign="center center">
        {{'login-dialog.Get Started FREE'|translate}}
      </div>
      <div  *ngIf="!hidetitle" fxFlexlayout="row" class="mat-h3 auto_margin" fxLayoutAlign="center center">
        {{'login-dialog.with the app aggregator'|translate}}
      </div>
      <div fxFlexlayout="row" style="height: 1ch"></div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <mat-spinner color="accent" strokeWidth="2" [diameter]="25" *ngIf="signinBtnBusy"></mat-spinner>
        <div id="buttonDiv"> </div>
        <google-login *ngIf="authService.isFromMobile"></google-login>
      </div>
      <div fxLayout="row" class="mat-h4 auto_margin" fxLayoutAlign="center center">
        {{'login-dialog.or'|translate}}
      </div>

      <div fxLayout="row" fxLayoutAlign="center center">
        <mat-button-toggle-group class="toggle_button" aria-label="Font Style" [(ngModel)]="loginToggle">
          <mat-button-toggle *ngFor="let option of loginOptions; trackBy: trackByFn" value="{{ option.id }}">{{ option.name | translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div fxFlexlayout="row" style="height: 2ch"></div>
      <mat-card appearance="outlined" fxLayout="column"  style="padding: 8px;"
      class="card-1" fxLayoutAlign="center center" *ngIf="loginToggle == 'signup'">
        <form [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)" class="form">

            <mat-form-field class="form-element" style="width: 100%;"  appearance="outline">
              <mat-icon matPrefix color="primary">email</mat-icon>
               <mat-label>{{'login-dialog.Email Address'|translate}}</mat-label>
               <input matInput formControlName="email" />
               <mat-error *ngIf="
                  !formGroup?.controls['email']?.valid &&
                  formGroup?.controls['email']?.touched
                  ">
                  {{ getErrorEmail() }}
            </mat-error>
             </mat-form-field>


          <mat-form-field class="form-element" style="width: 100%;" appearance="outline">
            <mat-icon matPrefix color="primary">badge</mat-icon>
            <mat-label>{{'login-dialog.First Name'|translate}}</mat-label>
            <input matInput formControlName="firstName" />
            <mat-error *ngIf="
                !formGroup?.controls['firstName']?.valid &&
                formGroup?.controls['firstName']?.touched
              ">
              <!-- {{ titleAlert }} -->
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-element" style="width: 100%" appearance="outline">
            <mat-icon matPrefix color="primary">badge</mat-icon>
            <mat-label>{{'login-dialog.Last Name'|translate}}</mat-label>
            <input matInput formControlName="lastName" />
            <mat-error *ngIf="
                !formGroup?.controls['lastName']?.valid &&
                formGroup?.controls['lastName']?.touched
              ">
              <!-- {{ titleAlert }} -->
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-element" style="width: 100%" appearance="outline">
            <mat-icon matPrefix color="primary">password</mat-icon>
            <mat-label>{{'login-dialog.Password'|translate}}</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide">
              <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
            </button>
            <mat-hint>
              <span [ngStyle.xs]="{'font-size': '10px'}">{{'login-dialog.Password Hint'|translate}}</span></mat-hint>
            <mat-error  *ngIf="
                !formGroup?.controls['password']?.valid &&
                formGroup?.controls['password']?.touched
              ">
              <span [ngStyle.xs]="{'font-size': '10px'}">{{ getErrorPassword() }}</span>
            </mat-error>
          </mat-form-field>
          <div fxFlexlayout="row" style="height: 20px" [ngStyle.xs]="{'height': '40px'}"></div>
          <mat-form-field class="form-element" style="width: 100%" appearance="outline">
            <mat-icon matPrefix color="primary">enhanced_encryption</mat-icon>
            <mat-label>{{'login-dialog.Confirm Password'|translate}}</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="confirmPassword" />
            <mat-error  *ngIf="
                !formGroup?.controls['confirmPassword']?.valid &&
                formGroup?.controls['confirmPassword']?.touched
              ">
              {{'login-dialog.Password Mismatch'|translate}}
            </mat-error>
          </mat-form-field>

          <div class="form-element" fxLayoutAlign="center center">
            <button mat-raised-button color="primary" type="submit" class="button" [disabled]="!formGroup?.valid || spinner">
              {{'login-dialog.Create Account'|translate}}
            </button>
          </div>
        </form>
        <div *ngIf="duplicateSignupError" style="padding-top: 1rem">
          <span style="color: red; margin-right: .5rem;">Email is already registered.</span>
          <span style="color: blue; text-decoration: underline; cursor: pointer" (click)="gotoSignin()">{{ "Sign In instead" }}</span>
        </div>
      </mat-card>

      <mat-card appearance="outlined" fxLayout="column" style="padding: 8px;"
      class="card-1" fxLayoutAlign="center center" *ngIf="loginToggle == 'signin'">
        <form [formGroup]="signInFormGroup" (ngSubmit)="onSubmitSignIn(signInFormGroup.value)" class="form">
          <mat-form-field class="form-element" style="width: 100%" appearance="outline">
            <mat-icon matPrefix color="primary">email</mat-icon>
            <mat-label>{{'login-dialog.Email Address'|translate}}</mat-label>
            <input matInput formControlName="email" />
            <mat-error *ngIf="
                !signInFormGroup?.controls['email']?.valid &&
                signInFormGroup?.controls['email']?.touched
              ">
              {{ getErrorEmail() }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-element" style="width: 100%" appearance="outline">
            <mat-icon matPrefix color="primary">password</mat-icon>
            <mat-label>{{'login-dialog.Password'|translate}}</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
            <!-- <mat-error *ngIf="signInFormGroup?.controls['password']?.touched">
              {{ getErrorPassword('signin') }}
            </mat-error> -->
          </mat-form-field>

          <div class="form-element" fxLayoutAlign="center center">
            <button mat-raised-button color="primary" type="submit" class="button" [disabled]="!signInFormGroup?.valid && loginToggle != 'signin' || spinner">
              {{'login-dialog.Sign In'|translate}}
            </button>
          </div>
        </form>
      </mat-card>
    </div>
    <div fxLayout="column" fxFlex="10" fxFlex.xs="5"></div>
  </div>
  <br/>
  <br/>
  <br/>
</div>
<mat-spinner class="centerOfAll" color="primary" strokeWidth="6" [diameter]="60" *ngIf="spinner"></mat-spinner>
